import { useTranslations } from 'next-intl';
import { useFontSize } from '@app/app/_context/AccessibilityContext/useFontSize';
import { FontSize } from '@app/domain/model/FontSize';
import { twMerge } from 'tailwind-merge';
import { Card } from '@app/app/_components/Card/Card';
import { ContactUsIcon } from '@app/app/_icons/ContactUsIcon';
import { Heading } from '@app/app/_components/Heading/Heading';
import { Paragraph } from '@app/app/_components/Paragraph/Paragraph';

export function ContactUsCard() {
    const t = useTranslations();
    const fontSize = useFontSize();

    return (
        <Card className="flex flex-row gap-4 p-6">
            <ContactUsIcon
                className={twMerge(
                    'size-20 rounded-full bg-neutral-50 p-2 text-primary-500',
                    fontSize !== FontSize.Normal && 'max-md:hidden',
                )}
            />

            <div className="flex flex-col">
                <Heading className="mb-3" level="h3">
                    {t('general.contactUs')}
                </Heading>
                <div className="flex flex-row gap-1">
                    <Paragraph isGray>{`${t('general.email')}:`}</Paragraph>
                    <Paragraph isBold className="cursor-pointer text-primary-500 hover:underline">
                        {t('general.emailValue')}
                    </Paragraph>
                </div>
                <div className="flex flex-row gap-1">
                    <Paragraph isGray>{`${t('general.telephoneLabel')}:`}</Paragraph>
                    <Paragraph isBold className="cursor-pointer text-primary-500 hover:underline">
                        {t('general.telephoneValue')}
                    </Paragraph>
                </div>
            </div>
        </Card>
    );
}
